import './footer.css'

function Footer(){
    return(
        <div>
            <div className='footer'>
                <p>
                    Heladopolis Puebla 2022
                </p>
            </div>
        </div>
    )
}

export default Footer;
